export enum AuthenticatorFormSteps {
  DETAILS = 'Basic Details',
  VARIABLES_MAPPING = 'Variables Mapping',
}
